import React from "react";
import "./SideNarBar.css";
import { useStaticQuery, graphql, Link } from "gatsby";
import { animated, useSpring } from "react-spring";

const SideNarBar = ({ toggleModal, modalIsOpen, style }) => {
  const getWindowWidth = () => {
    if (typeof window !== "undefined") {
      return window.innerWidth;
    }
  };

  const props = useSpring({
    right: modalIsOpen ? "0%" : "-600%",
    position: "fixed",
    top: 0,
    height: "100%",
    zIndex: 99999
  });

  const {
    allWordpressWpCategory: { nodes: categories },
    cities: { nodes: cities = [] }
  } = useStaticQuery(graphql`
    query {
      allWordpressWpCategory(
        filter: { name: { ne: "Uncategorized" }, count: { gt: 0 } }
      ) {
        nodes {
          id
          slug
          databaseId
          name
          parentId
          wpParent {
            node {
              id
              slug
            }
          }
        }
      }
      cities: allWordpressWpCategory(
        filter: {
          wpParent: { node: { slug: { eq: "city-guides" } } }
          count: { gt: 0 }
        }
      ) {
        nodes {
          id
          name
          slug
          content_category {
            bannerImage {
              sourceUrl
              altText
            }
          }
        }
      }
    }
  `);

  const findCategoryPath = slug => {
    let category = categories.find(category => (category || {}).slug === slug);
    if (!category) return null;
    if (category.wpParent) {
      return `/${(category.wpParent.node || {}).slug}/${(category || {}).slug}`;
    }
    return `/${(category || {}).slug}`;
  };

  const topCategories = [
    {
      name: "Legalization",
      slug: "legalization",
      path: findCategoryPath("legalization")
    },
    {
      name: "News",
      slug: "news",
      path: findCategoryPath("news")
    },
    {
      name: "How Tos",
      slug: "how-tos",
      path: findCategoryPath("how-tos")
    },
    {
      name: "Industry",
      slug: "industry",
      path: findCategoryPath("industry")
    },
    {
      name: "Recipes",
      slug: "recipes",
      path: "/recipes"
    },
    {
      name: "Strains",
      slug: "strains",
      path: "/strains"
    },
    {
      name: "Guides",
      slug: "guides",
      path: findCategoryPath("guides")
    },
    {
      name: "Events",
      slug: "events",
      path: findCategoryPath("events")
    },
    {
      name: "Gravity Bongs",
      slug: "gravity-bongs",
      path: findCategoryPath("gravity-bongs")
    }
  ];
  const backDropStyles = modalIsOpen
    ? {
        width: "100%",
        position: "fixed",
        right: 0,
        top: 0,
        background: "rgba(255, 255, 255, 0.75)",
        height: "100%",
        zIndex: 99999
      }
    : {
        display: "none"
      };
  return (
    <div style={{ ...backDropStyles }}>
      <animated.div style={props} className="animatedModalDiv">
        <section className="side-nav-panel">
          <div className="crossBtn">
            <div className="mobileModeLogo">
              <div className="mobileModeLogoImg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="94"
                  height="32"
                  viewBox="0 0 94 32"
                  fill="none"
                >
                  <path
                    d="M0 0H14.3686L14.385 0.0819732C14.2899 0.137715 14.1933 0.191817 14.0966 0.24592C12.0535 1.37059 10.964 3.11498 10.9231 5.42499C10.869 8.41701 10.9083 11.4107 10.91 14.4043C10.91 14.4683 10.9214 14.5306 10.9296 14.624C11.9369 14.6758 12.9465 14.5803 13.9262 14.3404C14.9092 14.0994 15.8595 13.7863 16.8048 13.4534C18.6308 12.8129 20.5472 12.4681 22.4818 12.4321C22.5605 12.4321 22.6375 12.4189 22.7554 12.4075V11.9681C22.7554 9.84826 22.7685 7.73007 22.7554 5.61025C22.7308 3.11498 21.6069 1.27222 19.3329 0.163946C19.2762 0.128142 19.2215 0.0892843 19.169 0.0475445H33.6424C33.5327 0.119681 33.4606 0.175423 33.3819 0.211491C31.2619 1.35912 30.1445 3.1281 30.1396 5.54303C30.1265 12.3894 30.1265 19.2364 30.1396 26.0839C30.1396 28.5431 31.2373 30.3563 33.4163 31.5154C33.4819 31.5515 33.5441 31.5957 33.6916 31.6794H19.1428C19.4361 31.5154 19.6343 31.4203 19.8358 31.3023C21.7134 30.1547 22.721 28.484 22.7423 26.2904C22.7767 22.7426 22.7521 19.1932 22.7521 15.6421V15.1946C21.8641 15.2831 21.0007 15.2978 20.1717 15.47C19.1628 15.6775 18.1705 15.9592 17.203 16.3127C15.3027 17.0178 13.2996 17.4055 11.2737 17.4603C11.1688 17.4603 11.0656 17.4767 10.9034 17.4882V17.9603C10.9034 20.6343 10.9034 23.3099 10.9034 25.9855C10.9034 28.4972 11.9831 30.3776 14.2326 31.5597C14.285 31.5859 14.3309 31.622 14.4701 31.7236C14.2801 31.7351 14.1965 31.7449 14.113 31.7449H0.119602C0.0786421 31.7449 0.0393211 31.7449 0 31.7449V31.6417C0.0573432 31.6089 0.114686 31.5761 0.173668 31.5466C2.34616 30.4465 3.50449 28.6857 3.51268 26.2495C3.53234 19.3211 3.51268 12.3943 3.51268 5.46597C3.5249 4.71546 3.38828 3.96997 3.11071 3.27263C2.83314 2.5753 2.42014 1.93996 1.8956 1.40338C1.36805 0.847603 0.763484 0.372158 0 0.163946V0Z"
                    fill="#3041FF"
                  />
                  <path
                    d="M71.3828 31.6925C71.5892 31.568 71.6925 31.5024 71.799 31.4433C72.9786 30.7876 73.6339 29.7875 73.7453 28.453C73.8256 27.5037 73.8994 26.5528 73.901 25.6019C73.9141 18.9151 73.9141 12.2277 73.901 5.53982C73.872 4.55044 73.7735 3.56432 73.6061 2.58878C73.4603 1.58871 72.8131 0.91653 71.989 0.393541C71.835 0.295173 71.6777 0.198445 71.5221 0.0984374C71.5221 0.0984374 71.5139 0.0771243 71.4975 0.023022C71.6302 0.023022 71.7514 0.00170898 71.8743 0.00170898C73.7437 0.00170898 75.6131 0.00170898 77.4808 0.00170898C77.7289 0.00852944 77.9726 0.0689294 78.1952 0.178771C79.6255 0.883741 80.2808 2.09858 80.3398 3.62984C80.4103 5.28242 80.4103 6.93664 80.4398 8.59086C80.4398 8.73349 80.4398 8.87613 80.4398 9.06139C80.8444 9.06139 81.2114 9.06139 81.5784 9.06139C83.3269 8.9984 85.0744 9.2131 86.7557 9.6975C90.5895 10.8451 93.0503 13.7962 93.4845 17.7751C93.7483 20.2065 93.5713 22.5755 92.6489 24.8625C91.3382 28.0939 88.8397 29.976 85.64 31.0663C84.3205 31.511 82.9363 31.7327 81.544 31.7221C78.2968 31.7221 75.0495 31.7221 71.8022 31.7221C71.7056 31.7204 71.6056 31.7073 71.3828 31.6925ZM80.4709 11.0648V29.717C81.1361 29.717 81.7718 29.7432 82.4042 29.717C82.8531 29.7036 83.2985 29.6331 83.7296 29.5071C85.2812 29.0153 86.2494 27.9628 86.5591 26.3446C87.0998 23.5067 86.9474 20.6852 86.2822 17.8915C85.83 15.9963 85.0633 14.2372 83.787 12.7371C82.9317 11.7222 81.8799 11.0746 80.4709 11.0648Z"
                    fill="#3041FF"
                  />
                  <path
                    d="M53.9199 18.8836H40.2591C40.5688 21.0526 41.0554 23.102 42.6528 24.6677C44.591 26.5662 46.8814 26.9941 49.4209 26.1071C50.8447 25.6153 52.0325 24.725 53.1171 23.6955C53.2089 23.6086 53.3055 23.5315 53.4005 23.4413L53.4923 23.4905C53.4071 23.7545 53.3285 24.0234 53.2351 24.2824C52.352 26.6449 51.002 28.6926 49.0326 30.2878C47.4057 31.5993 45.5085 32.0797 43.4294 31.9895C39.4186 31.8157 35.2899 28.6073 34.1562 23.9315C33.3484 20.6034 33.278 17.2491 34.5592 14.0259C36.0747 10.2109 38.8993 7.73692 42.9559 6.97621C46.675 6.27124 49.7699 7.60413 51.9965 11.1716C52.9713 12.7324 53.4612 14.4702 53.6922 16.2818C53.8003 17.1229 53.8429 17.9787 53.9199 18.8836ZM47.5139 16.2064C47.3697 15.3752 47.2632 14.5899 47.0944 13.8177C46.7995 12.4602 46.367 11.1486 45.5052 10.0174C45.1448 9.54853 44.7106 9.16654 44.1011 9.05505C43.1918 8.89111 42.5463 9.34032 42.0106 9.99119C40.9931 11.2257 40.536 12.6914 40.3361 14.2538C40.2493 14.8997 40.2067 15.5522 40.1428 16.2212L47.5139 16.2064Z"
                    fill="#3041FF"
                  />
                  <path
                    d="M66.8956 16.9813C66.9153 15.5271 66.8514 14.1565 66.5073 12.8154C66.3025 12.017 66.0158 11.2481 65.4457 10.6284C65.2306 10.3874 64.9629 10.1992 64.6635 10.0784C64.364 9.95758 64.0408 9.90735 63.7188 9.93161V10.3136C63.7188 15.6894 63.7188 21.0652 63.7336 26.4426C63.7575 27.2086 63.8364 27.9718 63.9695 28.7264C64.1333 29.8445 64.7674 30.6594 65.7193 31.243C65.8438 31.3184 65.9667 31.3971 66.0879 31.4774C66.1059 31.4906 66.1141 31.5201 66.1518 31.5824H54.6635C54.7515 31.5079 54.8439 31.4389 54.9404 31.3758C56.3477 30.6315 56.9359 29.3904 57.0391 27.8739C57.0998 26.9902 57.1358 26.1033 57.1358 25.218C57.1358 20.98 57.1358 16.7419 57.1129 12.5056C57.0864 11.8188 56.9992 11.1358 56.8524 10.4644C56.6525 9.40862 55.9808 8.6807 55.0944 8.1282L54.6504 7.85605C54.7581 7.82869 54.8676 7.80897 54.9781 7.79703C58.5825 7.79703 62.1869 7.78883 65.7914 7.80686C66.8251 7.81422 67.8488 8.00977 68.8125 8.38395C70.6737 9.09548 71.6731 10.5153 72.1401 12.3859C72.2564 12.8449 72.4972 13.3942 72.3432 13.763C72.1892 14.1319 71.6223 14.309 71.2193 14.5418C69.9086 15.2927 68.5979 16.0304 67.2872 16.7731C67.1741 16.837 67.0611 16.8944 66.8956 16.9813Z"
                    fill="#3041FF"
                  />
                </svg>
              </div>
            </div>
            <div className="sideNavCrossSvg">
              <svg
                className="sideDrawerCross"
                onClick={toggleModal}
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="24"
                viewBox="0 0 26 24"
                fill="none"
              >
                <ellipse
                  cx="12.5714"
                  cy="12"
                  rx="12.5714"
                  ry="12"
                  fill="#0A0909"
                />
                <line
                  x1="7.21"
                  y1="6.50387"
                  x2="18.6386"
                  y2="17.9324"
                  stroke="white"
                />
                <line
                  x1="7.21"
                  y1="6.50387"
                  x2="18.6386"
                  y2="17.9324"
                  stroke="white"
                />
                <line
                  x1="7.21"
                  y1="6.50387"
                  x2="18.6386"
                  y2="17.9324"
                  stroke="white"
                />
                <line
                  x1="18.6387"
                  y1="6.06791"
                  x2="7.21014"
                  y2="17.4965"
                  stroke="white"
                />
                <line
                  x1="18.6387"
                  y1="6.06791"
                  x2="7.21014"
                  y2="17.4965"
                  stroke="white"
                />
                <line
                  x1="18.6387"
                  y1="6.06791"
                  x2="7.21014"
                  y2="17.4965"
                  stroke="white"
                />
              </svg>
            </div>
          </div>
          <div className="side-nav-upper">
            <div className="leftSideNav">
              <ul className="top-nav">
                <p className="leftSideHeading">cities</p>
                {cities.map((city, index) => (
                  <li key={city.id}>
                    <Link to={`/city-guides/${(city || {}).slug}`}>
                      {city.name}
                    </Link>
                  </li>
                ))}
              </ul>
              <ul className="leftLowerNav">
                {/* <li className="leftLowerLinks">
                  <Link className="lowerLeftLinks" href="/giveaway">
                    GiveAways
                  </Link>
                </li> */}
                <li className="leftLowerLinks">
                  <Link className="lowerLeftLinks" href="/products">
                    products
                  </Link>
                </li>
                <li className="leftLowerLinks">
                  <Link className="lowerLeftLinks" href="/newsletters">
                    newsletters
                  </Link>
                </li>
              </ul>
            </div>
            <div className="rightSideNav">
              <ul className="top-nav-1">
                <p className="rightSideHeading">discover</p>
                {topCategories.map(category => {
                  if (category.path) {
                    return (
                      <li key={(category || {}).slug}>
                        <Link to={category.path}>{category.name}</Link>
                      </li>
                    );
                  }
                  return null;
                })}
              </ul>
              <ul className="rightLowerNav">
                <li className="rightLowerLinks">
                  <Link className="lowerRightLinks" href="/about-us">
                    about
                  </Link>
                </li>
                <li className="rightLowerLinks">
                  <Link
                    className="lowerRightLinks"
                    href="https://www.herb.agency/get-in-touch"
                  >
                    advertise with herb
                  </Link>
                </li>
                {/* <li className="rightFMDLowerLinks">
                  <a
                    className="lowerRightLinks"
                    href="https://www.nuggmd.com/herb24?utm_source=herb&utm_medium=site&utm_campaign=herb24&utm_content=getacardbutton"
                    target="_blank"
                  >
                    Get Med Card
                  </a>
                </li> */}
                <li className="rightLowerLinks">
                  <Link className="lowerRightLinks" href="/careers">
                    careers
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="side-nav-lower">
            <p className="sideNavLowerHeading">follow us</p>
            <div className="sideNarLogoSvgs">
              {/* <a href="/" className="svg1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    d="M12.0375 24C18.6597 24 24.0281 18.6274 24.0281 12C24.0281 5.37258 18.6597 0 12.0375 0C5.41526 0 0.046875 5.37258 0.046875 12C0.046875 18.6274 5.41526 24 12.0375 24Z"
                    fill="#3041FF"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.9066 4.65894C15.1549 6.74552 16.3172 7.98787 18.3289 8.11493V10.4472C17.158 10.5601 16.1339 10.1648 14.9433 9.45893V13.8354C14.9433 19.409 8.87178 21.1455 6.43698 17.1559C4.86832 14.5893 5.83039 10.0745 10.8608 9.8994V12.3756C10.4667 12.44 10.0781 12.5344 9.69843 12.658C8.5699 13.0335 7.94921 13.7479 8.12413 14.9987C8.46551 17.3959 12.8583 18.1046 12.4915 13.4232V4.67022H14.9179L14.9066 4.65894Z"
                    fill="#F7FFE3"
                  />
                </svg>
              </a> */}
              <a
                href="https://www.instagram.com/herb/"
                target="_blank"
                className="sideMenuSvgs"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    className="sideMenuSvgHover"
                    d="M12.0189 24C18.6412 24 24.0096 18.6274 24.0096 12C24.0096 5.37258 18.6412 0 12.0189 0C5.39671 0 0.0283203 5.37258 0.0283203 12C0.0283203 18.6274 5.39671 24 12.0189 24Z"
                    fill="#3041FF"
                  />
                  <path
                    d="M12.019 6.49373C13.8105 6.49373 14.025 6.49373 14.7331 6.53326C15.1592 6.53633 15.5813 6.61472 15.9801 6.7648C16.2691 6.87673 16.5315 7.04781 16.7507 7.26708C16.9698 7.48636 17.1407 7.749 17.2526 8.03819C17.4025 8.43731 17.4808 8.85982 17.4839 9.28621C17.5178 9.99491 17.5234 10.2095 17.5234 12.0024C17.5234 13.7954 17.5234 14.01 17.4839 14.7187C17.4808 15.1451 17.4025 15.5676 17.2526 15.9667C17.1407 16.2559 16.9698 16.5185 16.7507 16.7378C16.5315 16.9571 16.2691 17.1282 15.9801 17.2401C15.5813 17.3902 15.1592 17.4686 14.7331 17.4716C14.025 17.5055 13.8134 17.5112 12.019 17.5112C10.2246 17.5112 10.013 17.5112 9.30489 17.4716C8.87883 17.4686 8.45667 17.3902 8.05787 17.2401C7.77158 17.1256 7.51203 16.9531 7.2955 16.7335C7.07896 16.5139 6.91012 16.2519 6.79956 15.9638C6.64959 15.5647 6.57127 15.1422 6.56821 14.7159C6.53435 14.0071 6.52871 13.7926 6.52871 11.9996C6.52871 10.2067 6.52871 9.99209 6.56821 9.28338C6.57127 8.85699 6.64959 8.4345 6.79956 8.03539C6.91148 7.75016 7.08099 7.4911 7.2975 7.27442C7.51401 7.05774 7.77286 6.88809 8.05787 6.77608C8.45667 6.626 8.87883 6.54762 9.30489 6.54455C10.013 6.51067 10.2275 6.50502 12.019 6.50502V6.49373ZM12.019 5.29373C10.1964 5.29373 9.9679 5.29373 9.25129 5.33326C8.69395 5.34507 8.14262 5.45102 7.62056 5.64667C7.1711 5.81878 6.76293 6.08375 6.42265 6.4243C6.08236 6.76485 5.81761 7.17334 5.64563 7.62314C5.45014 8.14561 5.34426 8.69738 5.33247 9.25515C5.30143 9.97233 5.29297 10.201 5.29297 12.025C5.29297 13.849 5.29297 14.0777 5.33247 14.7949C5.35573 15.3455 5.47014 15.8884 5.67103 16.4015C5.843 16.8513 6.10776 17.2598 6.44804 17.6004C6.78832 17.9409 7.1965 18.2059 7.64595 18.378C8.16801 18.5736 8.71934 18.6796 9.27668 18.6914C9.99329 18.7224 10.2218 18.7309 12.0444 18.7309C13.867 18.7309 14.0955 18.7309 14.8121 18.6914C15.3694 18.6796 15.9208 18.5736 16.4428 18.378C16.8923 18.2059 17.3005 17.9409 17.6407 17.6004C17.981 17.2598 18.2458 16.8513 18.4178 16.4015C18.6133 15.879 18.7191 15.3273 18.7309 14.7695C18.762 14.0523 18.7704 13.8236 18.7704 11.9996C18.7704 10.1756 18.7704 9.94691 18.7309 9.22973C18.7191 8.67196 18.6133 8.12019 18.4178 7.59772C18.2458 7.14792 17.981 6.73943 17.6407 6.39888C17.3005 6.05833 16.8923 5.79336 16.4428 5.62125C15.9208 5.4256 15.3694 5.31965 14.8121 5.30784C14.0955 5.27679 13.867 5.26831 12.0444 5.26831L12.019 5.29373Z"
                    fill="#F7FFE3"
                  />
                  <path
                    d="M12.0189 8.54956C11.3371 8.54956 10.6705 8.75191 10.1035 9.13103C9.53657 9.51016 9.09467 10.049 8.83373 10.6795C8.57278 11.31 8.50451 12.0037 8.63754 12.673C8.77056 13.3423 9.09892 13.9571 9.58109 14.4397C10.0632 14.9222 10.6776 15.2508 11.3463 15.384C12.0151 15.5171 12.7083 15.4488 13.3383 15.1876C13.9683 14.9265 14.5067 14.4842 14.8856 13.9168C15.2644 13.3494 15.4666 12.6823 15.4666 11.9999C15.4666 11.0848 15.1034 10.2072 14.4568 9.56013C13.8102 8.91306 12.9333 8.54956 12.0189 8.54956ZM12.0189 14.239C11.5764 14.239 11.1439 14.1077 10.776 13.8616C10.408 13.6156 10.1213 13.2659 9.95194 12.8568C9.78261 12.4476 9.7383 11.9974 9.82463 11.5631C9.91095 11.1288 10.124 10.7298 10.4369 10.4167C10.7498 10.1035 11.1485 9.89026 11.5825 9.80386C12.0165 9.71747 12.4663 9.76182 12.8751 9.93129C13.2839 10.1008 13.6334 10.3877 13.8792 10.7559C14.125 11.1242 14.2563 11.5571 14.2563 11.9999C14.2563 12.5937 14.0205 13.1633 13.601 13.5832C13.1814 14.0031 12.6123 14.239 12.0189 14.239Z"
                    fill="#F7FFE3"
                  />
                  <path
                    d="M15.6018 9.22126C16.0475 9.22126 16.4087 8.85972 16.4087 8.41373C16.4087 7.96775 16.0475 7.6062 15.6018 7.6062C15.1562 7.6062 14.7949 7.96775 14.7949 8.41373C14.7949 8.85972 15.1562 9.22126 15.6018 9.22126Z"
                    fill="#F7FFE3"
                  />
                </svg>
              </a>
              <a
                href="https://www.threads.net/@herb"
                target="_blank"
                className="sideMenuSvgs"
                rel="noreferrer"
              >
                <svg
                  aria-label="Threads"
                  viewBox="0 0 192 192"
                  xmlns="http://www.w3.org/2000/svg"
                  width={25}
                  height={22}
                  class="threadsSiderBar"
                >
                  <path
                    class="x19hqcy"
                    d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z"
                  ></path>
                </svg>
              </a>
              <a
                href="https://ca.linkedin.com/company/herb"
                target="_blank"
                className="sideMenuSvgs"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    className="sideMenuSvgHover"
                    d="M12.0004 24C18.6226 24 23.991 18.6274 23.991 12C23.991 5.37258 18.6226 0 12.0004 0C5.37815 0 0.00976562 5.37258 0.00976562 12C0.00976562 18.6274 5.37815 24 12.0004 24Z"
                    fill="#3041FF"
                  />
                  <path
                    d="M5.45834 9.70123H8.24299V18.6631H5.45834V9.70123ZM6.85208 5.24854C7.17126 5.24854 7.48327 5.34326 7.74865 5.52072C8.01404 5.69819 8.22089 5.95041 8.34303 6.24553C8.46517 6.54064 8.49713 6.86538 8.43486 7.17867C8.3726 7.49196 8.2189 7.77974 7.9932 8.00561C7.76751 8.23148 7.47996 8.3853 7.16691 8.44762C6.85387 8.50994 6.52939 8.47795 6.2345 8.35571C5.93962 8.23347 5.68758 8.02646 5.51026 7.76086C5.33293 7.49527 5.23828 7.18302 5.23828 6.86359C5.23828 6.43525 5.40831 6.02444 5.71095 5.72156C6.0136 5.41868 6.42407 5.24854 6.85208 5.24854Z"
                    fill="#F7FFE3"
                  />
                  <path
                    d="M9.98828 9.70135H12.6544V10.9268H12.7052C12.9721 10.4698 13.3579 10.094 13.8215 9.83941C14.2851 9.5848 14.8091 9.46097 15.3375 9.48113C18.1588 9.48113 18.6751 11.3362 18.6751 13.7475V18.6632H15.8933V14.3065C15.8933 13.2675 15.8764 11.9291 14.4488 11.9291C13.0212 11.9291 12.7786 13.0585 12.7786 14.2303V18.6632H9.99957L9.98828 9.70135Z"
                    fill="#F7FFE3"
                  />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/c/herbvideo"
                target="_blank"
                className="sideMenuSvgs"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    className="sideMenuSvgHover"
                    d="M12.9809 24C19.6031 24 24.9715 18.6274 24.9715 12C24.9715 5.37258 19.6031 0 12.9809 0C6.35862 0 0.990234 5.37258 0.990234 12C0.990234 18.6274 6.35862 24 12.9809 24Z"
                    fill="#3041FF"
                  />
                  <path
                    d="M19.6961 14.6822C19.6946 15.1909 19.492 15.6784 19.1325 16.0382C18.7731 16.3979 18.2859 16.6007 17.7776 16.6022H8.1851C7.67674 16.6007 7.18963 16.3979 6.83016 16.0382C6.47069 15.6784 6.26809 15.1909 6.2666 14.6822V9.31746C6.26809 8.8087 6.47069 8.32121 6.83016 7.96146C7.18963 7.60171 7.67674 7.39895 8.1851 7.39746H17.7776C18.2859 7.39895 18.7731 7.60171 19.1325 7.96146C19.492 8.32121 19.6946 8.8087 19.6961 9.31746V14.6822ZM11.5932 13.6431L15.2243 11.7626L11.5932 9.88216V13.6431Z"
                    fill="#F7FFE3"
                  />
                </svg>
              </a>
              <a
                href="https://www.facebook.com/herb"
                target="_blank"
                className="sideMenuSvgs"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    className="sideMenuSvgHover"
                    d="M12.9623 24C19.5845 24 24.9529 18.6274 24.9529 12C24.9529 5.37258 19.5845 0 12.9623 0C6.34007 0 0.97168 5.37258 0.97168 12C0.97168 18.6274 6.34007 24 12.9623 24Z"
                    fill="#3041FF"
                  />
                  <path
                    d="M18.7975 5.43832H7.12851C6.93695 5.43832 6.75324 5.51448 6.61779 5.65003C6.48234 5.78559 6.40625 5.96944 6.40625 6.16114V17.8393C6.40625 18.031 6.48234 18.2148 6.61779 18.3504C6.75324 18.4859 6.93695 18.5621 7.12851 18.5621H13.4116V13.4797H11.6934V11.5033H13.4031V10.0407C13.4031 8.34655 14.4357 7.42325 15.9423 7.42325C16.4522 7.42135 16.9617 7.44776 17.4686 7.50232V9.27268H16.4219C15.5981 9.27268 15.4401 9.66514 15.4401 10.2383V11.5033H17.415L17.1583 13.4797H15.4655V18.5621H18.8088C19.0003 18.5621 19.184 18.4859 19.3195 18.3504C19.4549 18.2148 19.531 18.031 19.531 17.8393V6.16114C19.531 6.06526 19.512 5.97033 19.475 5.88189C19.438 5.79345 19.3838 5.71327 19.3155 5.646C19.2473 5.57873 19.1663 5.52571 19.0774 5.49006C18.9884 5.4544 18.8933 5.43682 18.7975 5.43832Z"
                    fill="#F7FFE3"
                  />
                </svg>
              </a>
              <a
                href="https://open.spotify.com/playlist/7DkimKAKZwHqhEWLPSwwFb"
                target="_blank"
                className="sideMenuSvgs"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    className="sideMenuSvgHover"
                    d="M12.7187 0.000180005C6.0914 0.000180005 0.71875 5.37278 0.71875 12.0002C0.71875 18.6278 6.0914 24.0002 12.7187 24.0002C19.3466 24.0002 24.7188 18.628 24.7188 12.0002C24.7188 5.37314 19.3466 0.000720018 12.7185 0.000720018L12.7187 0V0.000180005ZM18.2218 17.3078C18.0069 17.6602 17.5456 17.7722 17.1929 17.5557C14.3756 15.8346 10.8287 15.4449 6.65157 16.3993C6.24908 16.4909 5.84786 16.2387 5.75606 15.8361C5.6639 15.4334 5.91518 15.0322 6.31874 14.9406C10.8899 13.8962 14.8108 14.3458 17.974 16.2789C18.3266 16.4953 18.4384 16.9552 18.2218 17.3078ZM19.6906 14.0404C19.4197 14.4805 18.8437 14.6194 18.4038 14.3487C15.1782 12.366 10.2615 11.7917 6.44618 12.9501C5.95136 13.0995 5.42882 12.8206 5.2787 12.3267C5.12966 11.8319 5.40866 11.3104 5.90258 11.1599C10.2606 9.83761 15.6784 10.4781 19.3826 12.7544C19.8226 13.0253 19.9615 13.6013 19.6908 14.0407V14.0405L19.6906 14.0404ZM19.8168 10.6379C15.9491 8.34069 9.56829 8.12955 5.87576 9.25025C5.28284 9.43008 4.65572 9.09545 4.47608 8.50233C4.29644 7.90904 4.63088 7.28244 5.22416 7.10226C9.46299 5.81541 16.5095 6.06399 20.9623 8.70754C21.4967 9.02417 21.6717 9.71286 21.3549 10.2455C21.0395 10.7789 20.3489 10.9547 19.8173 10.6379H19.8168Z"
                    fill="#3041FF"
                  />
                </svg>
              </a>
              <a
                href="https://twitter.com/Herbworthy"
                target="_blank"
                className="sideMenuSvgs"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    className="sideMenuSvgHover"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M24.9248 12C24.9248 18.6274 19.5522 24 12.9248 24C6.29739 24 0.924805 18.6274 0.924805 12C0.924805 5.37258 6.29739 0 12.9248 0C19.5522 0 24.9248 5.37258 24.9248 12ZM18.9606 10.0979C18.9606 13.9199 16.0506 18.3299 10.7286 18.3299C9.09664 18.3299 7.57264 17.8499 6.30664 17.0219C6.53464 17.0519 6.76264 17.0639 6.99664 17.0639C8.35264 17.0639 9.60064 16.6019 10.5906 15.8279C9.32464 15.8039 8.25664 14.9699 7.89064 13.8179C8.07064 13.8539 8.25064 13.8719 8.43664 13.8719C8.70064 13.8719 8.95864 13.8359 9.19864 13.7699C7.87264 13.4999 6.87664 12.3359 6.87664 10.9319V10.8959C7.26664 11.1119 7.71064 11.2439 8.18464 11.2559C7.40464 10.7399 6.89464 9.85193 6.89464 8.84993C6.89464 8.32193 7.03864 7.82393 7.28464 7.39793C8.71264 9.14993 10.8426 10.3019 13.2486 10.4219C13.1946 10.2119 13.1706 9.98993 13.1706 9.76193C13.1706 8.16593 14.4666 6.86993 16.0626 6.86993C16.8966 6.86993 17.6466 7.21793 18.1746 7.78193C18.8346 7.64993 19.4526 7.40993 20.0106 7.07993C19.7946 7.75793 19.3386 8.32193 18.7386 8.68193C19.3266 8.60993 19.8846 8.45393 20.4006 8.22593C20.0106 8.80793 19.5186 9.31793 18.9546 9.72593C18.9606 9.84593 18.9606 9.97193 18.9606 10.0979Z"
                    fill="#3041FF"
                  />
                </svg>
              </a>
            </div>
          </div>
        </section>
      </animated.div>
    </div>
  );
};

export default SideNarBar;
